export default __webpack_public_path__ + "static/kds-7b666324f845b76e01cfa49221eab191.png";